export default __webpack_public_path__ + "assets/images/a75ae331c6a9329de51b13878603c955.jpg";